import { API_BASE_URL } from '../../../config/constants';
import { getAuthErrorMessage } from '../../auth/get-auth-error-message';
import { ChangeEmailParams } from './email.types';

export const changeEmail = async (params: ChangeEmailParams): Promise<void> => {
  const accessToken = localStorage.getItem('accessToken');
  const response = await fetch(`${API_BASE_URL}/v1/user/email`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(await getAuthErrorMessage(response, 'Failed to change email'));
  }
};
